import { stringify } from 'qs';
import request from '@/utils/request';

export async function getTenancies() {
  return request('/mvnos');
}

export async function addTenancy(params) {
  return request(
    '/mvnos',
    {
      method: 'POST',
      body: {
        ...params,
      },
    },
  );
}

export async function deleteTenancy({ spId }) {
  return request(`/mvnos/${spId}`, {
    method: 'DELETE',
  });
}

export async function updateTenancy(params) {
  return request('/mvnos', {
    method: 'PUT',
    body: {
      ...params,
    },
  });
}

export async function getRoles() {
  return request('/roles');
}

export async function getRolesByUserId(id) {
  return request(`/users/${id}/roles`);
}

export async function getHistory(params) {
  return request(`/mvnos/history?${stringify(params)}`);
}
